<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="view mtb80">
                    <div class="form_box">
                        <div class="input_wrap top">
                            <div class="inp_row">
                                <div class="inp_box">
                                    <label for="name">제목</label>
                                    <input type="text" disabled :value="maintenance?.title">
                                </div>
                            </div>
                        </div>
                        <div class="upload" v-if="maintenance?.img_path">
                            <img :src="apiBaseUrl + '/' + maintenance.img_path" alt="">
                        </div>
                        <hr>
                        <div class="input_wrap">
                            <div class="inp_row disa">
                                <div class="inp_box">
                                    <label for="name">이름</label>
                                    <input disabled :value="maintenance?.name">
                                </div>
                                <div class="inp_box">
                                    <label for="company">회사</label>
                                    <input disabled :value="maintenance?.company">
                                </div>
                                <div class="inp_box">
                                    <label for="tel">연락처</label>
                                    <input disabled :value="maintenance?.hp">
                                </div>
                            </div>
                            <div class="inp_row">
                                <div class="inp_box">
                                    <label for="address">해당 지역(위치)</label>
                                    <input disabled :value="maintenance?.location">
                                </div>
                                <div class="inp_box">
                                    <label for="date">수리/검사 희망 날짜</label>
                                    <input disabled :value="formattedRepairDate">
                                </div>
                                <div class="inp_box">
                                    <label for="date">방문 시간대</label>
                                    <input disabled :value="maintenance?.timezone">
                                </div>
                            </div>
                            <div class="inp_box">
                                <label for="content">내용</label>
                                <p class="textarea">{{ maintenance?.content }}</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="steps">
                                <div class="step" :class="{ active: isActive('문의등록') }">
                                    <span class="icon" :class="isActive('문의등록') ? 'chk' : 'non'"></span>
                                    <span class="text">문의 등록</span>
                                </div>

                                <div class="step" :class="{ active: isActive('문의확인') }">
                                    <span class="icon" :class="isActive('문의확인') ? 'chk' : 'non'"></span>
                                    <span class="text">문의 확인</span>
                                </div>

                                <div class="step" :class="{ active: isActive('업체매칭') }">
                                    <span class="icon" :class="isActive('업체매칭') ? 'chk' : 'non'"></span>
                                    <span class="text">업체 매칭</span>
                                </div>

                                <div class="step" :class="{ active: isActive('수리/검사') }">
                                    <span class="icon" :class="isActive('수리/검사') ? 'chk' : 'non'"></span>
                                    <span class="text">수리/검사</span>
                                </div>

                                <div class="step" :class="{ active: isActive('완료') }">
                                    <span class="icon" :class="isActive('완료') ? 'chk' : 'non'"></span>
                                    <span class="text">완료</span>
                                </div>
                            </div>
                        </div>

                        <div class="apply_box input_wrap" v-if="canApply">
                            <label>유지관리 신청 내용</label>
                            <div class="inp_box">
                                <textarea v-model="applyContent" rows="5"></textarea>
                            </div>

                            <button
                                class="buttn"
                                type="button"
                                @click="applyMaintenance"
                            >
                                신청하기
                            </button>
                        </div>

                        <div class="bottom_txt">
                            <div
                                class="info"
                                v-for="company in maintenance?.companies"
                                :key="company.id"
                            >
                                <p><strong>아이디 : </strong>{{ company.name }}</p>
                                <p><strong>회사명 : </strong>{{ company.company }}</p>

                                <p v-html="company.content.replace(/\n/g, '<br>')"></p>

                                <p class="row">
                                    <span>매칭 성공 횟수 : {{ company.match_count ?? 0 }}회</span>
                                    <span>
                                        매칭 요청 날짜 :
                                        {{ company.created_at.substring(0, 10) }}
                                    </span>
                                </p>

                                <div class="btns" v-if="canControlCompany">
                                    <button
                                        class="buttn cancel"
                                        type="button"
                                        @click="acceptCompany(company.id)"
                                    >
                                        요청수락
                                    </button>
                                    <button
                                        class="buttn"
                                        type="button"
                                        @click="rejectCompany(company.id)"
                                    >
                                        요청거절
                                    </button>
                                </div>

                                <div class="btns" v-if="canCompleteWork">
                                    <button
                                        v-if="maintenance.user_level == 1"
                                        class="buttn cancel"
                                        type="button"
                                        @click="completeMaintenance('검사완료')"
                                    >
                                        검사완료    
                                    </button>
                                    <button
                                        v-if="maintenance.user_level == 2"
                                        class="buttn"
                                        type="button"
                                        @click="completeMaintenance('수리완료')"
                                    >
                                        수리완료
                                    </button>
                                </div>    
                            </div>
                        </div>                        
                    </div>
                    <div class="btns">
                        <button class="buttn" type="button" onclick="window.location.href='/maintenance';">목록으로</button>
                    </div>
                    
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'    
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
    name: 'MaintenanceView',
    components: { TheHeader, TheFooter },

    data() {
        return {
            maintenance: null,
            apiBaseUrl: api.defaults.baseURL,
            applyContent: '',

            STATUS_ORDER: [
                '문의등록',
                '문의확인',
                '업체매칭',
                '수리/검사',
                '완료'
            ]
        }
    },

    async mounted() {
        const id = this.$route.query.id

        if (!id) {
            alert('잘못된 접근입니다.')
            this.$router.push('/maintenance')
            return
        }

        await this.loadMaintenance(id)
    },

    computed: {
        isOwner() {
            return (
                this.maintenance &&
                this.maintenance.login_user_id == this.maintenance.userid
            )
        },
        canControlCompany() {
            if (!this.maintenance) return false

            return (
                this.isOwner &&
                ['문의등록', '문의확인'].includes(this.maintenance.mstatus)
            )
        },  
        canCompleteWork() {
            if (!this.maintenance) return false
        
            return (
                this.maintenance.mstatus === '업체매칭' && 
                (this.isOwner || this.maintenance.user_level == 2)    
            )
        },
        formattedRepairDate() {
            if (!this.maintenance?.repair_date) return '';
            return this.maintenance.repair_date.substring(0, 10);
        },

        canApply() {
            if (!this.maintenance) return false

            return (
                this.maintenance.user_level === 2 &&
                ['문의등록', '문의확인'].includes(this.maintenance.mstatus) &&
                !this.maintenance.applied
            )
        }
    },

    methods: {
        async completeMaintenance(type) {
            if (!confirm(`${type} 처리를 하시겠습니까?`)) return

            try {
                const res = await api.post(
                    '/admin/maintenance_status_update', // 서버에 새로 만들 API 경로
                    {
                        maintenance_id: this.maintenance.id,
                        new_status: '수리/검사',
                        work_type: type // 검사완료인지 수리완료인지 구분값 전송
                    },
                    { withCredentials: true }
                )

                if (!res.data.success) {
                    alert(res.data.message)
                    return
                }

                alert(`${type} 처리가 완료되었습니다.`)
                // 페이지 새로고침하여 상태 반영 (데이터 다시 로드)
                await this.loadMaintenance(this.maintenance.id)

            } catch (e) {
                console.error(e)
                alert('처리 중 오류가 발생했습니다.')
            }
        },
        async applyMaintenance() {
            if (!this.applyContent.trim()) {
                alert('내용을 입력해주세요.')
                return
            }

            try {
                const res = await api.post(
                    '/admin/maintenance_apply',
                    {
                        maintenance_id: this.maintenance.id,
                        content: this.applyContent
                    },
                    { withCredentials: true }
                )

                if (!res.data.success) {
                    alert(res.data.message)
                    return
                }

                alert('신청이 완료되었습니다.')
                await this.loadMaintenance(this.maintenance.id)

            } catch (e) {
                console.error(e)
                alert('신청 중 오류가 발생했습니다.')
            }
        },

        async loadMaintenance(id) {
            try {
                const res = await api.get('/admin/maintenance_detail_api', {
                    params: { id },
                    withCredentials: true
                })

                if (!res.data.success) {
                    alert(res.data.message)
                    this.$router.push('/maintenance')
                    return
                }

                this.maintenance = {
                    ...res.data.maintenance,
                    user_level: res.data.user_level,
                    applied: res.data.applied,
                    login_user_id: res.data.login_user_id
                }
                console.log(this.maintenance)

            } catch (e) {
                console.error(e)
                alert('데이터를 불러오지 못했습니다.')
                this.$router.push('/maintenance')
            }
        },

        isActive(status) {
            if (!this.maintenance?.mstatus) return false

            const currentIndex = this.STATUS_ORDER.indexOf(this.maintenance.mstatus)
            const targetIndex = this.STATUS_ORDER.indexOf(status)

            if (currentIndex === -1 || targetIndex === -1) return false

            return targetIndex <= currentIndex
        },

        async acceptCompany(companyId) {
            if (!confirm('해당 업체를 매칭하시겠습니까?')) return

            try {
                const res = await api.post(
                    '/admin/maintenance_accept',
                    {
                        maintenance_id: this.maintenance.id,
                        company_id: companyId
                    },
                    { withCredentials: true }
                  ) 

                    if (!res.data.success) {
                        alert(res.data.message)
                        return
                 }

                   alert('업체가 매칭되었습니다.')
                  this.$router.go(0)

            } catch (e) {
                console.error(e)
                alert('처리 중 오류가 발생했습니다.')    
            }
        },

        async rejectCompany(companyId) {
            if (!confirm('해당 업체 요청을 거절하시겠습니까?')) return

            try {
                const res = await api.post(
                    '/admin/maintenance_reject',
                    {
                        maintenance_id: this.maintenance.id,
                        company_id: companyId
                    },
                    { withCredentials: true }
                )

                if (!res.data.success) {
                    alert(res.data.message)
                    return
                }

                alert('요청이 거절되었습니다.')
                this.$router.go(0)

            } catch (e) {
                console.error(e)
                alert('처리 중 오류가 발생했습니다.')
            }
        }
    }
}
</script>